import React from 'react';
import { hasAccessToRoute } from '@/domain-registry';
import type { DomainConfig } from '@/domain-registry';

export interface SearchEntry {
  label: string;
  description: string;
  path: string;
  domainName: string;
  domainIcon: React.ComponentType<any>;
}

export function buildSearchIndex(domains: DomainConfig[]): SearchEntry[] {
  const entries: SearchEntry[] = [];
  for (const domain of domains) {
    entries.push({
      label: domain.displayName,
      description: domain.description,
      path: domain.defaultRoute,
      domainName: domain.displayName,
      domainIcon: domain.icon,
    });
    for (const route of domain.routes) {
      if (route.path.includes(':') || route.path.endsWith('/*')) continue;
      if (!hasAccessToRoute(route)) continue;
      entries.push({
        label: `${domain.displayName} \u2014 ${route.name}`,
        description: route.description || '',
        path: route.path,
        domainName: domain.displayName,
        domainIcon: domain.icon,
      });
    }
  }
  return entries;
}
